export default __webpack_public_path__ + "static/logo-af0086caf9f038cf1508762ac4288c56.svg";